<div class="modal-header">
	<h4 class="modal-title" *ngIf="form_title != ''" [innerHtml]="form_title"></h4>
	<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
		<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="" transform="translate(-809.000000, -277.000000)" fill="#FFFFFF">
					<g id="" transform="translate(817.202796, 285.202796) rotate(-315.000000) translate(-817.202796, -285.202796) translate(806.702796, 274.202796)">
						<rect id="Rectangle-Copy" transform="translate(10.500000, 11.000000) rotate(-90.000000) translate(-10.500000, -11.000000) " x="-1.36424205e-12" y="10" width="21" height="2" rx="1"></rect>
						<rect id="Rectangle-Copy" transform="translate(10.500000, 11.000000) rotate(-360.000000) translate(-10.500000, -11.000000) " x="-1.36424205e-12" y="10" width="21" height="2" rx="1"></rect>
					</g>
				</g>
			</g>
		</svg>
	</button>
</div>
<div class="modal-body">
	<div class="modal-contents" *ngIf="form_content != ''">
		<div class="form_content" [innerHtml]="form_content | safe:'preamble'"></div>
	</div>
	<form [formGroup]="formGroup" id="convenor__send_press">
		<div class="form-group">
			<div class="floating-label date-picker" [class.input-filled]="DateFilled == true">
				<input class="form-control" formControlName="Date" ngbDatepicker #d="ngbDatepicker" min-date="minDate" value="selectToday()" (click)="d.toggle()" />
				<label for="date"><span>Date *</span></label>
				<i class="icon-breadcrumb-bottom"></i>
			</div>
			<bfv-messages></bfv-messages>
		</div>
		<div class="form-group">
			<div class="floating-label" [class.input-filled]="HeadlineFilled == true">
				<input type="text" class="form-control" id="headline" formControlName="Headline" autocomplete="off" />
				<label for="headline"><span>Headline *</span></label>
			</div>
			<bfv-messages></bfv-messages>
		</div>
		<div class="form-group">
			<div class="floating-label" [class.input-filled]="LinkFilled == true">
				<input type="text" class="form-control" id="link" formControlName="Link" autocomplete="off" />
				<label for="link"><span>Link *</span></label>
			</div>

			<bfv-messages></bfv-messages>
		</div>
		<div class="form-group">
			<div class="floating-label input-filled">
				<input type="text" class="form-control" id="organisation" formControlName="Organisation" autocomplete="off" />
				<label for="organisation"><span>Organisation *</span></label>
			</div>

			<bfv-messages></bfv-messages>
		</div>
		<div class="form-group text-right">
			<button type="submit" class="btn btn-primary btn-circle" [disabled]="sendButton" (click)="doSubmitConvenor()">Submit</button>
		</div>
		<div class="message-wrapper">
			<span class="error" *ngIf="errorMessage == true" id="signuperror" [innerHtml]="errorMessageText"></span>
		</div>
		<div class="col-12 text-center" *ngIf="sendButton">
			<span><span class="loading__circle loading__circle-small"></span> Sending</span>
		</div>
	</form>
</div>